angular.module('services.endpoints.EndpointsService', [
  'global'
])

/**
 * The EndpointsService service stores methods used to access
 * system APIs.
 *
 * @class EndpointsService
 * @constructor
 * @module services.endpoints.EndpointsService
 */
.factory('EndpointsService', [
  '$filter',
  'ModelsService',
  function ($filter, ModelsService) {
    'use strict';

    var service = {
      entries: [],

      current: {
        endpoint: null,
        instance: null
      },
      contentEdit: null,
      contentCreate: null,

      /**
       * Returns all entries from a provided model
       *
       * @param {Object} model - to retrieve entries for
       * @return {Array<Object>} All entries
       */
      getEntriesFromEndpoint: function getEntriesFromEndpoint(model) {
        service.entries = ModelsService.read(model);

        return service.entries;
      },

      /**
       * Returns the current endpooint based on a
       * provided key
       *
       * @param {string} key - reference for endpoint
       * @return {Object} Current model from endpoint
       */
      getCurrentEndpoint: function getCurrentEndpoint(key) {
        service.current.endpoint = ModelsService.find('endpoints', 'label', key);

        return service.current.endpoint;
      },

      /**
       * Returns the current instance based on a
       * provided key
       *
       * @param {string} key - reference for instance
       * @return {Object} Current instance from model
       */
      getCurrentInstance: function getCurrentInstance(key) {
        service.current.instance = _.find(service.entries, function (obj) {
          return obj[obj.primaryKey] === key;
        });

        return service.current.instance;
      },

      /**
       * Returns the content edit object
       *
       * @return {Object} Content edit object
       */
      getContentEdit: function getContentCreate() {
        service.contentEdit = service.setContentEdit();

        return service.contentEdit;
      },

      /**
       * Sets the contentEdit Object based on the
       * current instace
       */
      setContentEdit: function setContentEdit() {
        var contentEdit = {
          schema: null,
          form: null,
          model: {}
        };
        contentEdit.schema = service
          .removeLabelFromSchema(
            ModelsService.find('schemas', 'label', service.current.instance.schema).content.schema
          );
        contentEdit.form = service
          .removeLabelFromForm(
            ModelsService.find('schemas', 'label', service.current.instance.schema).content.form
          );
        contentEdit.model = ModelsService
          .find('schemas', 'label', service.current.instance.schema).content.model
          || {};

        if (service.current.endpoint.label === 'schemas') {
          contentEdit.model.schema = $filter('json')(service.current.instance.content.schema, 4);
          contentEdit.model.form = $filter('json')(service.current.instance.content.form, 4);
          contentEdit.model.model = $filter('json')(service.current.instance.content.model, 4);
        } else {
          contentEdit.model = _.clone(service.current.instance.content);
        }

        return contentEdit;
      },

      /**
       * Formats and saves content on existing instance
       *
       * @param {Object} content - Content data used to update instance
       * @param {string} schema - Schema used to validate the content
       * @param {Object} instance - Instance to update
       */
      saveContentEditData: function saveContentEditData(content, schema, instance) {
        var data = {};

        data.content = content;
        data.schema = schema;

        if (schema === 'schemas' && data.content.schema && data.content.form) {
          data.content.schema = JSON.parse(data.content.schema);
          data.content.form = JSON.parse(data.content.form);
        }
        return ModelsService.update(instance, data);
      },

      /**
       * Returns the content creation object
       *
       * @return {Object} Content creation object
       */
      getContentCreate: function getContentCreate() {
        service.contentCreate = service.setContentCreate();

        return service.contentCreate;
      },

      /**
       * Sets the contentCreate Object based on the
       * current endpoint
       */
      setContentCreate: function setContentCreate() {
        var schema = ModelsService.find('schemas', 'label', service.current.endpoint.label);
        var contentCreate = {};

        contentCreate.schema = service.addLabelToSchema(schema.content.schema);
        contentCreate.form = service.addLabelToForm(schema.content.form);
        contentCreate.model = schema.content.model || {};

        return contentCreate;
      },

      /**
       * Formats and saves content create data to create
       * a new instance on a model
       *
       * @param {Object} content - Content data used to create instance
       * @param {string} schema - Schema used to validat the content
       */
      saveContentCreateData: function saveContentCreateData(content, schema) {
        var data = {};

        data.content = content;
        data.label = data.content.label;
        data.schema = schema;

        // remove content label
        delete data.content.label;

        if (schema === 'schemas' && data.content.schema && data.content.form) {
          data.content.schema = JSON.parse(data.content.schema);
          data.content.form = JSON.parse(data.content.form);
        }
        return ModelsService.create(service.current.endpoint, data);
      },

      /**
       * Adds a default "label" property to a schema
       *
       * @param {Object} schema - JSON Schema
       * @return {Object} Updated JSON Schema
       */
      addLabelToSchema: function addLabelToSchema(schema) {
        var altered = _.clone(schema);

        altered.required.push('label');
        altered.properties.label = { type: 'string' };

        return altered;
      },

      /**
       * Adds a default "label" property to a form
       *
       * @param {Object} form - JSON Form Object
       * @return {Object} Updated JSON Form Object
       */
      addLabelToForm: function addLabelToForm(form) {
        var altered = _.clone(form);

        altered.unshift('label');

        return altered;
      },

      /**
       * Removes the default "label" property from a schema
       *
       * @param {Object} schema - JSON Schema
       * @return {Object} Updated JSON Schema
       */
      removeLabelFromSchema: function removeLabelFromSchema(schema) {
        var altered = schema;

        altered.required = _.reject(altered.required, function (str) {
          return str === 'label';
        });

        delete altered.properties.label;

        return altered;
      },

      /**
       * Removes the default "label" property from a form
       *
       * @param {Object} form - JSON Form Object
       * @return {Object} Updated JSON Form Object
       */
      removeLabelFromForm: function removeLabelFromForm(form) {
        var altered = form;

        altered = _.reject(altered, function (str) {
          return str === 'label';
        });

        return altered;
      }


    };

    return service;
  }
]);
